import React from 'react';
import PropTypes from 'prop-types';
import { Alert, Spinner } from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import CommonTable from '../../CommonTable/CommonTable';
import { injectIntl, FormattedMessage } from 'react-intl';
import messages from '../../../locale/messages';
// Style
import cs from '../../../components/commonStyle.css';
import s from './CarScanAiDocumentManagement.css';
import history from '../../../core/history';
import getCarScanAiTypesQuery from './CarScanAiTypes.graphql';
import getReservationReportQuery from './getReservationReportQuery.graphql';
import overrideCarScanRequirementMutation from './overrideCarScanRequirementMutation.graphql';
import { graphql, compose } from "react-apollo";

import cx from 'classnames';
import RemarksModal from './RemarksModal';
import CustomPagination from '../../CustomPagination/CustomPagination';
import { Button } from 'react-bootstrap';
import ImageDisplayModal from './ImageDisplayModal';
import OverrideScanModal from './OverrideScanModal';
import { ArrowLeftIcon, ArrowRightIcon } from '../../../helpers/common/ArrowIcons';
import { downloadCarScanAIPDF, openCarScanAIPDF } from '../../../helpers/pdfReportGenerator';
import { analysisAPI } from '../../../config';
import InspectionReport from './InspectionReport';
import ScanMetricsPanel from './ScanMetricsPanel';
import RepairRatesPanel from './RepairRatesPanel';

class CarScanAiDocumentManagement extends React.Component {

  static propTypes = {  
    title: PropTypes.string.isRequired,
    reservationId: PropTypes.number.isRequired,
    data: PropTypes.shape({
      loading: PropTypes.bool,
      error: PropTypes.object,
      getCarScanAiPhotoList: PropTypes.array,
    }),
    getCarScanAiTypes: PropTypes.shape({
      loading: PropTypes.bool,
      error: PropTypes.object,
      getCarScanAiTypes: PropTypes.array,
    }),
    getReservationReport: PropTypes.shape({
      loading: PropTypes.bool,
      error: PropTypes.object,
      getReservationReport: PropTypes.object,
    }),
  };
  static defaultProps = {
    data: {
      loading: true,
      
        count: null,
        getCarScanAiPhotoList: []
      
    }
  };

  // Pagination handler
  paginationData = (page) => {
    this.setState({ currentPage: page });
  };

  constructor(props) {
    super(props);
    this.state = {
      scanType: '',
      capturedAt: '',
      pendingScanType: '',
      pendingCapturedAt: '',
      showRemarkModal: false,
      selectedRemark: '',
      currentPage: 1,
      pageSize: 5,
      showImageModal: false,
      modalImageIndex: 0,
      modalImagesList: [],
      showInspectionReport: false,
      isGeneratingReport: false,
      generateError: '',
      showOverrideModal: false,
      overrideReason: '',
      overrideSubmitting: false,
      overrideError: '',
      overrideDone: false
    };
    this.statusPoller = null;
  }

  componentDidMount() {
    this.syncPollingWithStatus();
  }

  componentDidUpdate(prevProps) {
    // If reservation or report status changed, re-evaluate polling
    const prevData = prevProps.getReservationReport && prevProps.getReservationReport.getReservationReport;
    const currData = this.props.getReservationReport && this.props.getReservationReport.getReservationReport;
    const prevStatus = prevData && prevData.report;
    const currStatus = currData && currData.report;
    if (prevStatus !== currStatus) {
      this.syncPollingWithStatus();
    }
  }

  componentWillUnmount() {
    this.stopStatusPolling();
  }

  startStatusPolling = () => {
    if (this.statusPoller || !this.props.getReservationReport || !this.props.getReservationReport.refetch) return;
    this.statusPoller = setInterval(() => {
      this.props.getReservationReport.refetch();
    }, 5000);
  }

  stopStatusPolling = () => {
    if (this.statusPoller) {
      clearInterval(this.statusPoller);
      this.statusPoller = null;
    }
  }

  syncPollingWithStatus = () => {
    const reservationData = this.getReservationData();
    const status = reservationData && typeof reservationData.report === 'string' ? reservationData.report.toLowerCase() : '';
    const inProgress = ['processing', 'in_progress', 'pending', 'started'].includes(status);
    const finished = ['completed', 'error'].includes(status);
    if (inProgress) {
      this.startStatusPolling();
    } else if (finished || !status) {
      this.stopStatusPolling();
    }
  }

 

  // Get reservation data from GraphQL props (no manual fetching needed)
  getReservationData = () => {
    const { getReservationReport } = this.props;
    
    if (getReservationReport && getReservationReport.getReservationReport) {
      const reservation = getReservationReport.getReservationReport;
      
      // Handle JSON data properly - reportText comes as a string from GraphQL
      let parsedReportText = null;
      if (reservation.reportText) {
        try {
          // Parse the JSON string to an object
          parsedReportText = JSON.parse(reservation.reportText);
        } catch (error) {
          console.error('Error parsing reportText JSON:', error);
          // If parsing fails, keep as string
          parsedReportText = reservation.reportText;
        }
      }

      return {
        ...reservation,
        reportText: parsedReportText
      };
    }
    
    return null;
  };

  

  render() {
    const { data, getReservationReport, reservationId } = this.props;
    const list = (data && Array.isArray(data.getCarScanAiPhotoList)) ? data.getCarScanAiPhotoList : [];

    // If showing inspection report, render that instead
    if (this.state.showInspectionReport) {
      const reservationData = this.getReservationData();
      if (reservationData && reservationData.reportText) {
        return (
          <InspectionReport 
            reservationData={reservationData}
            reportData={reservationData.reportText}
            onBack={() => this.setState({ showInspectionReport: false })}
          />
        );
      }
    }

    // Fetch scan type options from GraphQL
    const { getCarScanAiTypes } = this.props;
    const scanTypeOptions = getCarScanAiTypes && getCarScanAiTypes.getCarScanAiTypes
      ? getCarScanAiTypes.getCarScanAiTypes.map(type => type.title)
      : [];
      
    // Get reservation data directly from GraphQL props
    const reservationData = this.getReservationData();
    const statusStr = reservationData && reservationData.report ? String(reservationData.report) : '';
    const normalizedStatus = statusStr.toLowerCase();
    const isError = normalizedStatus === 'error';
    const isCompletedStatus = normalizedStatus === 'completed';
    const isProcessing = ['processing', 'in_progress', 'pending', 'started'].includes(normalizedStatus);
    const hasReportText = Boolean(reservationData && reservationData.reportText);
    const hasReportId = Boolean(reservationData && reservationData.report_id);
    const showViewReportButton = Boolean(reservationData && (isCompletedStatus || hasReportText || hasReportId));

    // Determine if photos exist for this reservation
    const hasPhotos = Array.isArray(list) && list.some(doc => Array.isArray(doc.photos) && doc.photos.length > 0);
    const isCompleted = reservationData && (reservationData.reservationState === 'completed' || reservationData.reservationState === 'COMPLETED');
    const isReportPending = Boolean(
      reservationData &&
      !hasReportText &&
      (!reservationData.report || (typeof reservationData.report === 'string' && reservationData.report.toLowerCase() !== 'completed'))
    );
    const canGenerateReport = Boolean(isCompleted && isReportPending && hasPhotos);
      

    // Get unique captured dates from the list
    const capturedAtOptions = Array.from(new Set(list.map(doc => doc.scan_time)));

    // Filtering logic
    const applyFilters = () => {
      // Apply the pending values to the actual filters and reset to first page
      this.setState({
        scanType: this.state.pendingScanType,
        capturedAt: this.state.pendingCapturedAt,
        currentPage: 1
      });
    };

    // Handle dropdown changes (update only pending values)
    const handleScanTypeChange = (e) => {
      this.setState({ pendingScanType: e.target.value });
    };
    const handleCapturedAtChange = (e) => {
      this.setState({ pendingCapturedAt: e.target.value });
    };
    const handleSubmit = (e) => {
      e.preventDefault();
      applyFilters();
    };
    const handleBack = () => {
      history.push('/siteadmin/reservations'); // Change path if needed
    };
    const   handleViewReport = () => {
    // Show the inspection report instead of PDF
    this.setState({ showInspectionReport: true });
  };

    // Override the car scan requirement so an incomplete photo set no longer
    // blocks trip completion. Admin only — the API rejects anyone else.
    const handleConfirmOverride = async () => {
      const reason = this.state.overrideReason.trim();
      if (!reservationId || !reason) return;

      this.setState({ overrideSubmitting: true, overrideError: '' });
      try {
        const { data } = await this.props.overrideCarScanRequirement({
          variables: { reservationId: parseInt(reservationId, 10), reason },
        });
        const result = data && data.overrideCarScanRequirement;
        if (result && result.status === 200) {
          this.setState({
            showOverrideModal: false,
            overrideSubmitting: false,
            overrideReason: '',
            overrideDone: true
          });
          if (this.props.getReservationReport && this.props.getReservationReport.refetch) {
            this.props.getReservationReport.refetch();
          }
        } else {
          this.setState({
            overrideSubmitting: false,
            overrideError: (result && result.errorMessage) || 'Override failed.'
          });
        }
      } catch (e) {
        this.setState({ overrideSubmitting: false, overrideError: e.message });
      }
    };

    const handleGenerateReport = async () => {
      if (!reservationId) return;
      this.setState({ isGeneratingReport: true, generateError: '' });
      try {
        const url = `${analysisAPI.baseURL}${analysisAPI.endpoint}/${reservationId}`;
        const res = await fetch(url, {
          method: 'POST',
          headers: { 'accept': 'application/json' },
          body: JSON.stringify({})
        });
        if (!res.ok) {
          throw new Error(`HTTP ${res.status}`);
        }
        // Refresh reservation report status
        if (this.props.getReservationReport && this.props.getReservationReport.refetch) {
          await this.props.getReservationReport.refetch();
          this.syncPollingWithStatus();
        }
      } catch (e) {
        this.setState({ generateError: 'Failed to trigger analysis. Please try again.' });
      } finally {
        this.setState({ isGeneratingReport: false });
      }
    };


    // Filtering and pagination logic (like ManageReservation.js)
    let filteredList = list;
    if (this.state.scanType) {
      filteredList = filteredList.filter(doc => doc.title === this.state.scanType);
    }
    if (this.state.capturedAt) {
      filteredList = filteredList.filter(doc => doc.scan_time === this.state.capturedAt);
    }
    // 1. Flatten all rows (one per photo, or one per doc if no photos)
    let allRows = [];
    let allImages = [];
    filteredList.forEach(doc => {
      if (Array.isArray(doc.photos) && doc.photos.length > 0) {
        doc.photos.forEach(photo => {
          const remark = photo.remark || '-';
          const truncatedRemark = (remark.length > 10 ? remark.substring(0, 10) + '...' : remark);
          // Collect image info for modal navigation
          if (photo.uploadFile) {
            allImages.push({
              url: photo.uploadFile,
              title: doc.title || '-',
              docId: doc.id,
              photoId: photo.id,
              remark: photo.remark || '-'
            });
          }
          allRows.push({
            id: `${doc.id}_${photo.id}`,
            data: [
              { data: photo.id },
              { data: doc.title || '-' },
              { data: (
                <span
                  style={{ color: remark.length > 10 ? '#007bff' : undefined, cursor: remark.length > 10 ? 'pointer' : undefined, textDecoration: remark.length > 10 ? 'underline' : undefined }}
                  onClick={() => {
                    if (remark.length > 10) this.setState({ showRemarkModal: true, selectedRemark: remark });
                  }}
                >
                  {truncatedRemark}
                </span>
              ) },
              { data: doc.scan_time === 'before' ? this.props.intl.formatMessage(messages.beforeRide) : this.props.intl.formatMessage(messages.afterRide) || '-' },
              { data: photo.uploadFile ? (
                  <span
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      // Find index in allImages
                      const idx = allImages.findIndex(img => img.url === photo.uploadFile && img.title === (doc.title || '-') && img.docId === doc.id && img.photoId === photo.id);
                      this.setState({
                        showImageModal: true,
                        modalImageIndex: idx,
                        modalImagesList: allImages
                      });
                    }}
                  >
                    <img src={photo.uploadFile} alt="Car Scan" style={{ width: 80, height: 60, objectFit: 'cover' }} />
                  </span>
                ) : this.props.intl.formatMessage(messages.noPhoto) }
            ]
          });
        });
      } else {
        allRows.push({
          id: `${doc.id}_noPhoto`,
          data: [
            { data: doc.id },
            { data: doc.title || '-' },
            { data: '-' },
            { data: doc.scan_time === 'before' ? this.props.intl.formatMessage(messages.beforeRide) : this.props.intl.formatMessage(messages.afterRide) || '-' },
            { data: this.props.intl.formatMessage(messages.noPhoto) }
          ]
        });
      }
    });
    // 2. Paginate the flat array
    const { currentPage, pageSize } = this.state;
    const paginatedRows = allRows.slice((currentPage - 1) * pageSize, currentPage * pageSize);
    // Table header as function (array of objects with data property)
    const { intl } = this.props;
    const thead = () => [
      { data: intl.formatMessage(messages.idCol) },
      { data: intl.formatMessage(messages.scanTypeCol) },
      { data: intl.formatMessage(messages.remarksCol) },
      { data: intl.formatMessage(messages.capturedAtCol) },
      { data: intl.formatMessage(messages.photoCol) },
    ];

    // Table body as function (array of objects with id and data)
    const tbody = () => paginatedRows;

    return (<>
      <div className={cx(s.pagecontentWrapper)}>
        <div className="card mb-4">
          <h1 className={cx(cs.commonTotalText, cs.spaceBottom5, cs.fontWeightBold)}>
            <FormattedMessage {...messages.carScanAiDocumentList} />
          </h1>

          {/* On the screen operations already opens, rather than in a dashboard
              of its own — a dashboard nobody visits measures nothing. */}
          <ScanMetricsPanel />

          {/* The price list behind every repair estimate. Here rather than in
              its own screen for the same reason as the metrics: this is the
              page operations already has open. */}
          <RepairRatesPanel />
          <div className="card-body p-3">
            <form onSubmit={handleSubmit}>
            {/* //for row display */}
              <div className={cx(s.filterBar)}>
                <label htmlFor="scanTypeSelect" className={cx(s.filterLabel)}>
                  <FormattedMessage {...messages.scanType} />
                </label>
                <select
                  id="scanTypeSelect"
                  className={cx(s.filterSelect)}
                  value={this.state.pendingScanType}
                  onChange={handleScanTypeChange}
                >
                  <option value="">{intl.formatMessage(messages.all)}</option>
                  {scanTypeOptions.map(opt => (
                  <option key={opt} value={opt}>{opt}</option>
                  ))}
                </select>
                <label htmlFor="capturedAtSelect" className={cx(s.filterLabel)}>
                  <FormattedMessage {...messages.capturedAt} />
                </label>
                <select
                  id="capturedAtSelect"
                  className={cx(s.filterSelect)}
                  value={this.state.pendingCapturedAt}
                  onChange={handleCapturedAtChange}
                >
                  <option value="">{intl.formatMessage(messages.all)}</option>
                  {capturedAtOptions.map(opt => (
                    <option key={opt} value={opt}>
                    {opt === 'before' ? this.props.intl.formatMessage(messages.beforeRide) : opt === 'after' ? this.props.intl.formatMessage(messages.afterRide) : opt}
                  </option>
                  ))}
                </select>
                <button type="submit" className={cs.btnPrimary}>
                  <FormattedMessage {...messages.submit} />
                </button>
                <button type="button" className={cs.btnPrimary} onClick={handleBack}>
                  <FormattedMessage {...messages.back} />
                </button>
                {showViewReportButton && (
                  <button type="button" className={`${cs.btnPrimary} viewReportBtn`} onClick={handleViewReport}>
                   View Report
                  </button>
                )} 
                {canGenerateReport && (
                  <button
                    type="button"
                    className={cs.btnPrimary}
                    onClick={handleGenerateReport}
                    disabled={this.state.isGeneratingReport || isProcessing}
                    style={{ marginLeft: 10 }}
                  >
                    {this.state.isGeneratingReport || isProcessing ? 'Generating…' : (isError ? 'Retry Generate Report' : 'Generate Report')}
                  </button>
                )}
                {!isCompleted && (
                  <button
                    type="button"
                    className={cs.btnPrimary}
                    onClick={() => this.setState({ showOverrideModal: true, overrideError: '' })}
                    style={{ marginLeft: 10 }}
                  >
                    Override Scan Requirement
                  </button>
                )}
              </div>
            </form>
          </div>
        </div>
        {reservationData && statusStr && (
          <Alert variant={isError ? 'danger' : (isProcessing ? 'info' : 'secondary')} className={cs.spaceBottom3}>
            <div>
              <strong>Status:</strong> {statusStr}
            </div>
            {isError && reservationData.report_error_message && (
              <div style={{ marginTop: 6 }}>
                <strong>Error:</strong> {reservationData.report_error_message}
              </div>
            )}
          </Alert>
        )}
        {this.state.overrideDone && (
          <Alert variant="warning" className={cs.spaceBottom3}>
            Car scan requirement overridden. This trip can now be completed without a
            full photo set, and the override is recorded against the reservation.
          </Alert>
        )}
        {this.state.generateError && (
          <Alert variant="danger" className={cs.spaceBottom3}>
            {this.state.generateError}
          </Alert>
        )}
      
        <div className="tableCarscan">
          <CommonTable
            thead={thead}
            tbody={tbody}
            title=""
            isHeadingHide={true}
            
          />
        </div>
{
      allRows.length > 0
          && <div>
            <CustomPagination
                total={allRows.length}
                currentPage={this.state.currentPage}
              defaultCurrent={1}
              defaultPageSize={this.state.pageSize}
              change={this.paginationData}
              paginationLabel={this.props.intl.formatMessage(messages.panelReservation)}
            />
          </div>
        }
       
        {/* Remark Modal - structure inspired by AdminClaimModal.js */}

        <RemarksModal
          show={this.state.showRemarkModal}
          onHide={() => this.setState({ showRemarkModal: false, selectedRemark: '' })}
          remark={this.state.selectedRemark}
          className={cx(s.remarkModal, 'languageModalContainer languageModalRTL')}
          intl={this.props.intl}
        />

        {/* Car scan override confirmation */}
        <OverrideScanModal
          show={this.state.showOverrideModal}
          onHide={() => this.setState({ showOverrideModal: false, overrideError: '' })}
          onConfirm={handleConfirmOverride}
          reason={this.state.overrideReason}
          onReasonChange={value => this.setState({ overrideReason: value })}
          submitting={this.state.overrideSubmitting}
          error={this.state.overrideError}
          className={cx(s.remarkModal, 'languageModalContainer languageModalRTL')}
        />

        {/* Image Modal for photo click */}
        <ImageDisplayModal
          show={this.state.showImageModal}
          onHide={() => this.setState({ showImageModal: false })}
          images={this.state.modalImagesList}
          currentIndex={this.state.modalImageIndex}
          onPrev={() => {
            this.setState(prev => {
              if (prev.modalImageIndex > 0) {
                return { modalImageIndex: prev.modalImageIndex - 1 };
              }
              return null;
            });
          }}
          onNext={() => {
            this.setState(prev => {
              if (prev.modalImagesList && prev.modalImageIndex < prev.modalImagesList.length - 1) {
                return { modalImageIndex: prev.modalImageIndex + 1 };
              }
              return null;
            });
          }}
        />

      </div>
        </>
    );
  }
}

export default compose(
  injectIntl,
  withStyles(s, cs),
  graphql(getCarScanAiTypesQuery, { name: 'getCarScanAiTypes' }),
  graphql(getReservationReportQuery, { 
    name: 'getReservationReport',



      options: (props) => {
        // ReservationId is expected as a prop (from route params)
        const { reservationId } = props;    
        const variables = reservationId !== undefined
          ? { reservationId: parseInt(reservationId) } // Use correct variable name and convert to Int
          : { reservationId: 102 }; // Default fallback
        return {
          variables,
          fetchPolicy: 'network-only',
        }
      },
      }),
  graphql(overrideCarScanRequirementMutation, { name: 'overrideCarScanRequirement' }),
)(CarScanAiDocumentManagement);

